<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row :gutter="20">
        <el-col :lg="14">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span class="cardHeader">管理员信息表</span>
            </div>

            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="id" label="主键" align="center"> </el-table-column>
              <el-table-column prop="loginName" label="账号">
                <template slot-scope="scope"> {{ scope.row.loginName }}({{ scope.row.userName }}) </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间"></el-table-column>

              <el-table-column fixed="right" label="角色" align="center">
                <template slot-scope="scope">
                  {{ getRoleLabel(scope.row.roleType) }}
                </template>
              </el-table-column>

              <el-table-column prop="builtIn" label="内置？" align="center"></el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>

              <el-table-column fixed="right" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="small" @click="delRow(scope.row.id)" v-if="scope.row.builtIn == 'N'">移除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div style="margin: 20px 0 0 -5px">
              <el-pagination background layout="prev, pager, next" :total="total" :page-size="pagesize" :current-page="currentPage" @current-change="pageChange"> </el-pagination>
            </div>
          </el-card>
        </el-col>

        <el-col :lg="10">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span class="cardHeader">添加管理员</span>
            </div>

            <el-form label-width="100px" :model="form" ref="formData">
              <el-form-item
                label="账号选择"
                prop="user"
                :rules="[
                  {
                    required: true,
                    min: 1,
                    message: '请选择人员',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="form.user" placeholder="点击按钮选择人员" class="input-with-select" :readonly="true" style="width: 300px">
                  <el-input></el-input>
                  <el-button slot="append" icon="el-icon-search" @click="searchUser">选择</el-button>
                </el-input>
              </el-form-item>

              <el-form-item label="分配角色">
                <el-select v-model="form.roleType" placeholder="请选择角色">
                  <el-option label="管理员" value="1"></el-option>
                  <el-option label="查重员" value="2"></el-option>
                  <el-option label="财务人员" value="3"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="备注信息" prop="remark">
                <el-input v-model="form.remark"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="add">确认新增</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-drawer title="选择账号" :visible.sync="drawer" :direction="'rtl'" :size="600">
      <div style="padding: 20px">
        <SearchUser :single="true" :closeFun="closeDrawer" :yesFun="selectUser"></SearchUser>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import SearchUser from "@/components/SearchUser.vue"
import adminApi from "@/api/admin"

export default {
  components: { PageHeader, SearchUser },
  data() {
    return {
      headLinks: [{ path: "", title: "管理员设置" }],
      drawer: false,
      tableData: [],
      total: 0,
      pagesize: 15,
      currentPage: 0,
      form: {
        user: "",
        userId: 0,
        roleType: null,
        remark: "",
      },
      roleTypeArr: [
        { value: 1, label: "管理员" },
        { value: 1, label: "查重员" },
        { value: 1, label: "财务人员" },
      ],
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    getRoleLabel(roleType) {
      let roleTypeArr = [
        { value: 1, label: "管理员" },
        { value: 2, label: "查重员" },
        { value: 3, label: "财务人员" },
      ]
      for (let i = 0; i < roleTypeArr.length; i++) {
        if (roleTypeArr[i].value == roleType) {
          return roleTypeArr[i].label
        }
      }
      //return roleTypeArr[roleType].label;
    },
    loadData() {
      adminApi.getListForPage("createTime", "DESC", this.currentPage, this.pagesize).then((res) => {
        this.total = res.total
        this.tableData = res.rows
      })
    },

    pageChange(curPage) {
      this.currentPage = curPage
      this.loadData()
    },

    closeDrawer() {
      this.drawer = false
    },
    searchUser() {
      this.drawer = true
    },

    selectUser(rows) {
      this.form.user = rows[0].loginName + "（" + rows[0].userName + "）"
      this.form.userId = rows[0].userId
      this.drawer = false
      this.$refs.formData.validateField("user")
      //console.log(rows);
    },

    add() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          adminApi.add(this.form.userId, this.form.remark, this.form.roleType).then((res) => {
            if (res.code == 0) {
              this.$notify({
                title: "成功",
                message: "添加成功",
                type: "success",
              })
              this.form.userId = 0
              this.form.user = ""
              this.form.remark = ""
              this.loadData()
            } else {
              this.$notify.error({
                title: "错误",
                message: "添加失败" + res.msg,
              })
            }
          })
        }
      })
    },

    delRow(id) {
      this.$confirm("确定移除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        adminApi.delete(id).then((res) => {
          if (res.code == 0) {
            this.$notify({
              title: "成功",
              message: "移除成功",
              type: "success",
            })
            this.loadData()
          } else {
            this.$notify.error({
              title: "错误",
              message: "删除失败" + res.msg,
            })
          }
        })
      })
    },
  },
}
</script>
